import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Header from '../components/Header';
import Footer from '../components/Footer';
import './Login.css';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setPasswordError('');
    
    const result = await login(username, password);
    if (result.success) {
      navigate('/dashboard');
    } else {
      const errorMsg = result.error || 'Ошибка входа';
      setError(errorMsg);
      setPasswordError(errorMsg);
    }
  };

  return (
    <div className="auth-page">
      <Header />
      <div className="login-container">
        <div className="login-box">
          <h2>Вход</h2>
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label>Имя пользователя</label>
              <input
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
              />
            </div>
            <div className="form-group">
              <label>Пароль</label>
              <input
                type="password"
                value={password}
                onChange={(e) => {
                  setPassword(e.target.value);
                  if (e.target.value && error) {
                    setPasswordError(error);
                  } else {
                    setPasswordError('');
                  }
                }}
                required
              />
              {passwordError && <div className="password-error">{passwordError}</div>}
            </div>
            {error && !passwordError && <div className="error">{error}</div>}
            <button type="submit" className="btn-primary">Войти</button>
          </form>
          <div className="register-links">
            <Link to="/register/student">Регистрация для ученика</Link>
            <Link to="/register/teacher">Регистрация для преподавателя</Link>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Login;

